import { ImpactModule } from 'types'
import { REGULATION_PAGES } from './pages'
import { REGULATION_PAGES_ORDER_FOR_PERMISSIONS } from './pagesOrderForPermissions'

export const REGULATION_MODULE: ImpactModule = {
  NAME: 'regulation',
  UPPER_NAME: 'REGULATION',
  API_NAME: 'REGULATION',
  NAME_PTBR: 'Regulação',
  PAGES: REGULATION_PAGES,
  PAGES_ORDER_FOR_PERMISSIONS: REGULATION_PAGES_ORDER_FOR_PERMISSIONS,
}
